import BaseEntityService from "core/framework/BaseEntityService";
import env from "environment";

class ProviderService extends BaseEntityService {
  constructor() {
    super({
      baseUrl: env.baseUrl + "/providers"
    });
  }
}

const service = new ProviderService();

export default service;
